import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO =
    "https://customer-assets.emergentagent.com/job_2e4f9de3-0bb7-4f65-a448-938d9d2f8e50/artifacts/j174pbvz_Opteris%20PNG.png";

const links = [
    { href: "#nosotros", label: "Nosotros" },
    { href: "#servicios", label: "Productos" },
    { href: "#clientes", label: "Clientes" },
    { href: "#testimonios", label: "Testimonios" },
    { href: "#contacto", label: "Contacto" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 10);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-white/85 backdrop-blur-xl border-b border-gray-100 shadow-sm"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-20">
                    <a
                        href="#top"
                        data-testid="logo-link"
                        className="flex items-center gap-3"
                    >
                        <img
                            src={LOGO}
                            alt="Creaciones Opteris"
                            className="h-12 w-auto object-contain"
                        />
                    </a>

                    <nav className="hidden md:flex items-center gap-8">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={`nav-link-${l.label.toLowerCase()}`}
                                className="text-sm font-semibold text-gray-700 hover:text-[#ea4d87] transition-colors relative group"
                            >
                                {l.label}
                                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#f4861c] group-hover:w-full transition-all duration-300" />
                            </a>
                        ))}
                    </nav>

                    <a
                        href="#contacto"
                        data-testid="navbar-cta-contact"
                        className="opteris-btn-primary hidden md:inline-flex text-sm"
                    >
                        Solicitar cotización
                    </a>

                    <button
                        onClick={() => setOpen(!open)}
                        data-testid="mobile-menu-toggle"
                        className="md:hidden p-2 text-gray-800"
                        aria-label="Menú"
                    >
                        {open ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="md:hidden bg-white border-t border-gray-100 shadow-lg"
                >
                    <div className="px-4 py-4 flex flex-col gap-3">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                                className="text-gray-800 font-semibold py-2 border-b border-gray-100"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="#contacto"
                            onClick={() => setOpen(false)}
                            data-testid="mobile-cta-contact"
                            className="opteris-btn-primary text-sm justify-center mt-2"
                        >
                            Solicitar cotización
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
